document.addEventListener('DOMContentLoaded', () => {
    // =====================
    // Constants & Selectors
    // =====================
    // Define action categories for analytics/events (unused, but useful for reference)
    // CATEGORY_ACTIONS = {
    //     new_session: ['enter_popup', 'enter_searchpage', 'field_reset'],
    //     fail: ['no_result', 'start_deleting', 'resign'],
    //     exploring: ['scrolled', 'loaded_more', 'mouse_over'],
    //     success: ['product_hit', 'collection_hit', 'wishlist', 'add_to_cart'],
    // };

    // Get references to key DOM elements
    const searchInput = document.getElementById('searchfield') || document.getElementById('popupsearchformfield');
    const searchButton = document.querySelector('.hvg-menu-grid li.s');
    const searchPageWrapper = document.querySelector('#hvgsearchresults');
    const searchPopupWrapper = document.querySelector('header div.search');
    const searchPopupClose = document.querySelector('.search .close');

    // =====================
    // App State Variables
    // =====================
    const TYPING_DELAY_MS = 3000; // Delay before sending 'no_result' event
    const lang = window.Shopify.locale;
    const country = window.Shopify.country;
    const userId = typeof hvgUserId !== 'undefined' ? hvgUserId : '';
    
    let phrase = searchInput?.value || '';
    let prevPhrase = null;
    let typingTimeout = null;
    let searchPopupOpen = false;
    let categoryHandler = null; // Tracks last event type sent to prevent duplicates
    let result_count = 0;
    let sessionId = null;
    let productId = '';
    let product =  typeof productSMHandle !== 'undefined' ? productSMHandle : '';
    let collection = '';
    let collectionId = "";
    let hasScrollListener = false; // Prevents multiple scroll listeners
    const place = window.location.href;
    const fetchUrl = 'https://enroute.hiveberg.com/analytics/event/search';
    

    // =====================
    // Utility Functions
    // =====================

    // Generate a random alphanumeric key of given length
    const generateRandomKey = (length) => {
        const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        return Array.from({ length }, () => chars.charAt(Math.floor(Math.random() * chars.length))).join('');
    };

    // Find productID and productHandle for addToCart
    const getProductData = (e) => {
        const productDataWrapper = e.parentElement.querySelector('.product-item-info')
        const productData = JSON.parse(productDataWrapper?.getAttribute('data-product'));
        product = productData.handle
        productId = productData.id
    }

    // Check if add to cart got variants
    const findifVariantAvaiable = (e) => {
        const parent = e.parentElement;
        if (!parent) return false;
        getProductData(e)

        const productVariantContainer = parent.querySelector('.product-swiper-container')
        if (!productVariantContainer) return false;
        const variantsPicker = productVariantContainer.querySelectorAll('.product-size-picker')
        if(!variantsPicker || variantsPicker.length == 0) return false;

        variantsPicker?.forEach( el => {
            el.addEventListener('click', () => sendData('success','add_to_cart'))
        })
        return true
      };

    // Extract product data from a DOM element (for wishlist/product hit)
    const getData = (element) => {
        const wishlistElement = element.querySelector('[data-wishlist]');
        if (!wishlistElement) return;
        const wishlistData = JSON.parse(wishlistElement.getAttribute('data-wishlist'));
        productId = wishlistData?.id || '';
    }

    const categoryValidation = (type) => {
        if (phrase !== prevPhrase) return false;

        const isSameCategory = categoryHandler === type && type !== 'add_to_cart';
        const isMouseOverToScroll = categoryHandler === 'mouse_over' && type === 'scrolled';
        const isScrollToMouseOver = categoryHandler === 'scrolled' && type === 'mouse_over';
      
        return isSameCategory || isMouseOverToScroll || isScrollToMouseOver;
    }

    // Centralized function to send/log analytics/event data
    const sendData = (category, type) => {

        // Prevent sending the same event type repeatedly
        if(categoryValidation(type)) return 
        if(category === 'new_session') sessionId = generateRandomKey(16)
        categoryHandler = type;
        prevPhrase = phrase;
        const data = {
            sessionId,
            lang,
            country,
            userId,
            phrase,
            resultCount: result_count != null && !isNaN(Number(result_count)) ? Number(result_count) : null,
            type,
            category,
            place,
            'productHandle': product,
            productId,
            'collectionHandle': collection,
            collectionId
        };

        console.log('Search event:', type,data)
        return new Promise((resolve, reject) => {
            fetch(fetchUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            })
            .then(response => response.text())
            .then(data => {
                if(!data.includes("Event recorded")){
                    console.log('Search event: Promise error ->', data)
                }
                else{
                    console.log('Search event: data added ->', data)
                }
            })
            .then(result => resolve(result))
            .catch(error => reject(error));
        });
    };

    // Helper to update phrase and send product/collection hit
    const productData = (newSessionId, newPhrase, type) => {
        phrase = newPhrase;
        sessionId = newSessionId;
        sendData('success',type)
    }

    // Update anchor element's href with session and search params
    const updateAnchorWithSearchParams = (anchor, sessionId, phrase, result_count) => {
        let url = new URL(anchor.href, window.location.origin);
        url.searchParams.set('sessionId', sessionId);
        url.searchParams.set('phrase', phrase);
        url.searchParams.set('result_count', result_count);
        anchor.href = url.toString();
        anchor.addEventListener('click', ()=> {
             categoryHandler = 'product_hit'
        })
    };

    // =====================
    // DOM Observers & Dynamic Event Binding
    // =====================

    // Observe changes in the DOM to update result count and attach click handlers to dynamic items
    const initSearchResultObserver = () => {
        const observer = new MutationObserver(() => {
            // Update search results count if the counter exists
            const resultCounter = document.querySelector('#hvg-search-results-count');
            if (resultCounter)  result_count = resultCounter.value;

            // Attach scroll listener only once for popup results
            const resultContainerPopup = document.querySelector('#shopify-section-search_results_popup')
            if(resultContainerPopup){
                const popupWrapper = document.querySelector('.serch_results_popup_wrapper')
                if (!hasScrollListener) {
                    popupWrapper.addEventListener('scroll', handleSearchPageScroll);
                    hasScrollListener = true;
                }

                // Update all product and collection links with session/search params
                const resultItems = document.querySelectorAll('.product-item')
                resultItems?.forEach(e => updateAnchorWithSearchParams(e, sessionId, phrase, result_count))

                const resultCollection = document.querySelectorAll('.collection-item')
                resultCollection?.forEach(e => updateAnchorWithSearchParams(e, sessionId, phrase, result_count))
               
                // Track mouse movement over popup results 
                resultContainerPopup.addEventListener('mouseover', () => {
                    if(categoryHandler !== 'mouse_over' || phrase !== prevPhrase) sendData('exploring', 'mouse_over');
                }, {});
            }

            // Update product links and attach click handler in grid results
            const resultContainerPage = document.querySelector('#shopify-section-search_results_grid')
            if(resultContainerPage){
                const addToCardButton = document.querySelectorAll('.hvg-product-item-button');
                addToCardButton?.forEach((e) =>{ 
                    if (!e._variantListenerAdded) {
                        e.addEventListener('click', ()=> {
                            const variantSelector = findifVariantAvaiable(e)
                            if(!variantSelector) sendData('success','add_to_cart')
                        })
                        e._variantListenerAdded = true;
                    }
                })

                document.querySelectorAll('.product-item').forEach(e => {
                    updateAnchorWithSearchParams(e, sessionId, phrase, result_count);
                    // Mark product hit on click
                    e.addEventListener('click', ()=> {
                        categoryHandler = 'product_hit'
                    })
                })
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };

    // =====================
    // Event Handlers
    // =====================

    // Handle user input in the search field
    const handleSearchInput = (e) => {
        const rawValue = e.target.value;
        //heck for null values, do not send null as a string
        const newValue = rawValue != null ? String(rawValue) : rawValue;

        // If user deletes characters, send 'start_deleting' event
        if (phrase?.length > newValue?.length && categoryHandler !== 'start_deleting') sendData('fail', 'start_deleting');
        if (typeof newValue === 'string')  phrase = newValue;

        // If input is cleared, send 'field_reset' event
        if (newValue.length === 0)  {
            result_count = 0;
            sendData('new_session', 'field_reset');
        }

        // Debounce: after user stops typing, check for no results
        clearTimeout(typingTimeout);
        typingTimeout = setTimeout(() => {
            if (result_count == 0 && categoryHandler !== 'resign') sendData('fail', 'no_result');
        }, TYPING_DELAY_MS);
    };

    const handleSearchPaste = (e) => {
        // Only trigger if the field is non-empty and all text is selected
        if(phrase?.length === 0) return
        const input = e.target;
        const isAllSelected = input.selectionStart === 0 && input.selectionEnd === input.value.length;
        if (input.value.length > 0 && isAllSelected) {
            setTimeout(() => {
                sendData('fail', 'field_replaced');
            }, 0);
        }
    };

    // Handle search button click (open/close popup)
    const handleSearchButtonClick = () => {
        if (!phrase && !searchPopupOpen) {
            sessionId = generateRandomKey(16);
            sendData('new_session', 'enter_popup');
        } else if (searchPopupOpen) {
            sendData('fail', 'resign');
        }

        searchPopupOpen = !searchPopupOpen;
    };

    // Handle scroll on search page (user exploring results)
    const handleSearchPageScroll = () => {
        if (categoryHandler !== 'scrolled' || phrase !== prevPhrase) sendData('exploring', 'scrolled');
    };

    // Handle clicks on 'load more' and wishlist buttons
    const handleLoadMoreClick = (e) => {
        if(e.target.classList.contains('hvg-more-btn'))  {
            const target = e.target;
            e.preventDefault();
            sendData('exploring', 'loaded_more');
            const href = target.getAttribute('href');

            if(!href) return
            const url = new URL(href, window.location.origin);
            url.searchParams.set('sessionId', sessionId);

            window.location.href = url.toString();
        }
        if(e.target.classList.contains('hvg-icon-heart-o')) sendData('success', 'wishlist');
    };

    // Handle page unload (user exits/resigns)
    const handleBeforeUnload = () => {
        const categoryValidation = !(categoryHandler === 'product_hit' || categoryHandler === 'collection_hit' || categoryHandler === 'loaded_more');
        if (searchPopupOpen && phrase.length > 0 && categoryValidation)  sendData('fail', 'resign');
    };

    // Extracts the last segment from a path (e.g., product or collection handle)
    const extractHandle = (path) => {
        const segments = path.split('/').filter(Boolean); // Removes empty strings from leading slashes
        return segments[segments.length - 1]; // Gets the last part
    }

    // =====================
    // Initialization
    // =====================

    // On search page load, send 'enter_searchpage' if input is empty and set up scroll handler
    const checkInitialSearchPage = () => {
        if (window.location.pathname.includes('/search')) {
            if (!phrase)  sendData('new_session', 'enter_searchpage');
            window.addEventListener('scroll', handleSearchPageScroll);
        }
    };

    // Immediately-invoked function to handle product/collection page logic
    (() => {

        const urlParams = new URLSearchParams(window.location.search);
        sessionId = urlParams.get('sessionId');
        console.log('sessionId->',sessionId,urlParams)
        if (!sessionId) {
            sessionId = generateRandomKey(16)
        }
        // Check if we are on a product or collection page by URL pattern
        const actualPath = window.location.pathname;
        const isProductPage = actualPath.includes('/products/');
        const isCollectionPage = actualPath.includes('/collections/');
        if (!isProductPage && !isCollectionPage) return;
      
        // Read URL parameters
        phrase = urlParams.get('phrase');
        result_count = urlParams.get('result_count');
        const dataHandle = extractHandle(actualPath);
      
        // Proceed only if both parameters are present
        if (sessionId && phrase) {
            if(isProductPage){
                // Product page: get product ID and handle, send product hit
                const productInput = document.querySelector('.hvg-express-checkout-buttons input[name="product-id"]')
                productId = productInput?.value || "";
                product = dataHandle;
                productData(sessionId,phrase,'product_hit');

                // Track add to cart button click
                const addToCardButton = document.querySelector('.red-hvg-add-button-text');
                addToCardButton?.addEventListener('click', ()=>{
                    sendData('success','add_to_cart')
                })
            }
            else {
                // Collection page: get collection ID and handle, send collection hit
                const collectionInput = document.querySelector('#hvg-collection-id')
                collectionId = collectionInput?.value || "";
                collection = dataHandle;
                productData(sessionId,phrase,'collection_hit');

                // Track add to cart button clicks for all products in collection
                const addToCardButton = document.querySelectorAll('.hvg-product-item-button');
                addToCardButton?.forEach((e) =>{ e.addEventListener('click', ()=>{
                    const variantSelector = findifVariantAvaiable(e)
                    if(!variantSelector) sendData('success','add_to_cart')})
                })
            }
        }
    })();

    // Attach all main event listeners
    const attachEventListeners = () => {
        searchInput?.addEventListener('input', handleSearchInput);
        searchInput?.addEventListener('paste', handleSearchPaste);
        searchButton?.addEventListener('click', handleSearchButtonClick);
        searchPageWrapper?.addEventListener('click', handleLoadMoreClick);
        searchPopupWrapper?.addEventListener('click', handleLoadMoreClick);
        searchPopupClose?.addEventListener('click',()=>sendData('fail','resign'))
        window.addEventListener('beforeunload', handleBeforeUnload);
    };

    initSearchResultObserver();
    checkInitialSearchPage();
    attachEventListeners();
});
